"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReview = createReview;
exports.deleteReview = deleteReview;
exports.editReview = editReview;
exports.getRating = getRating;
exports.getReviews = getReviews;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _analytics = require("../../utils/analytics");
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var actions = _interopRequireWildcard(require("./actionTypes"));
var events = _interopRequireWildcard(require("./events"));
var reviewsSelectors = _interopRequireWildcard(require("./selectors"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createReviewRequest(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    minorVersion = _ref.minorVersion,
    review = _ref.review;
  return {
    type: actions.CREATE_REVIEW.REQUEST,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    },
    review: review
  };
}
function replaceReview(_ref2) {
  var groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    version = _ref2.version,
    minorVersion = _ref2.minorVersion,
    review = _ref2.review,
    tempId = _ref2.tempId;
  return {
    type: actions.REPLACE_REVIEW,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    },
    review: review,
    tempId: tempId
  };
}
function createReviewFailure(_ref3) {
  var groupId = _ref3.groupId,
    assetId = _ref3.assetId,
    minorVersion = _ref3.minorVersion,
    version = _ref3.version,
    id = _ref3.id;
  return {
    type: actions.CREATE_REVIEW.FAILURE,
    id: id,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    }
  };
}
function createReviewSuccess() {
  return _objectSpread({
    type: actions.CREATE_REVIEW.SUCCESS
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.REVIEW_CREATED
  }));
}
function fetchReviewsRequest() {
  return {
    type: actions.FETCH_REVIEWS.REQUEST
  };
}
function fetchReviewsSuccess(_ref4) {
  var groupId = _ref4.groupId,
    assetId = _ref4.assetId,
    version = _ref4.version,
    minorVersion = _ref4.minorVersion,
    reviews = _ref4.reviews;
  return {
    type: actions.FETCH_REVIEWS.SUCCESS,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    },
    reviews: reviews
  };
}
function fetchReviewsFailure() {
  return {
    type: actions.FETCH_REVIEWS.FAILURE
  };
}
function deleteReviewSuccess() {
  return _objectSpread({
    type: actions.DELETE_REVIEW.SUCCESS
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.REVIEW_DELETED
  }));
}
function deleteReviewRequest(_ref5) {
  var groupId = _ref5.groupId,
    assetId = _ref5.assetId,
    version = _ref5.version,
    minorVersion = _ref5.minorVersion,
    id = _ref5.id;
  return {
    type: actions.DELETE_REVIEW.REQUEST,
    id: id,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    }
  };
}
function editReviewSuccess() {
  return _objectSpread({
    type: actions.EDIT_REVIEW.SUCCESS
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.REVIEW_EDITED
  }));
}
function editReviewRequest(_ref6) {
  var groupId = _ref6.groupId,
    assetId = _ref6.assetId,
    version = _ref6.version,
    minorVersion = _ref6.minorVersion,
    reviewToUpdate = _ref6.reviewToUpdate;
  return {
    type: actions.EDIT_REVIEW.REQUEST,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    },
    reviewToUpdate: reviewToUpdate
  };
}
function editReviewFailure() {
  return {
    type: actions.EDIT_REVIEW.FAILURE
  };
}
function updateRating(_ref7) {
  var groupId = _ref7.groupId,
    assetId = _ref7.assetId,
    version = _ref7.version,
    minorVersion = _ref7.minorVersion;
  return {
    type: actions.UPDATE_RATING,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion
    }
  };
}

/** Creates a new review for the asset portal */
function createReview(_ref8) {
  var groupId = _ref8.groupId,
    assetId = _ref8.assetId,
    version = _ref8.version,
    minorVersion = _ref8.minorVersion,
    review = _ref8.review;
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref9) {
      var config, state, reviewService, context, profile, createdBy, createdDate, tempId, newReview, createdReview;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref9.config;
            state = getState();
            reviewService = new _exchangeApiClient.ReviewService(config);
            context = sessionSelectors.context(state);
            profile = sessionSelectors.profile(state);
            createdBy = {
              firstName: profile.firstName,
              lastName: profile.lastName
            };
            createdDate = new Date().toISOString();
            tempId = Date.now().toString();
            newReview = _objectSpread(_objectSpread({}, review), {}, {
              version: version,
              canDelete: true,
              canEdit: true,
              createdBy: createdBy,
              createdDate: createdDate,
              updatedDate: createdDate,
              userId: profile.id
            });
            dispatch(createReviewRequest({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              review: _objectSpread(_objectSpread({}, newReview), {}, {
                id: tempId
              })
            }));
            _context.prev = 10;
            _context.next = 13;
            return reviewService.create({
              groupId: groupId,
              assetId: assetId,
              version: version,
              rating: review.rating,
              text: review.text,
              title: review.title,
              context: context
            });
          case 13:
            createdReview = _context.sent;
            dispatch(replaceReview({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              review: createdReview,
              tempId: tempId
            }));
            dispatch(createReviewSuccess());
            dispatch(updateRating({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion
            }));
            _context.next = 23;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](10);
            dispatch(createReviewFailure({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              id: tempId
            }));
            throw _context.t0;
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[10, 19]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref10.apply(this, arguments);
    };
  }();
}

/** Gets rating for the asset portal */
function getRating(_ref11) {
  var groupId = _ref11.groupId,
    assetId = _ref11.assetId,
    minorVersion = _ref11.minorVersion,
    version = _ref11.version;
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState, _ref12) {
      var config, state, reviewService, reviewsFromState, context, reviews, response;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            config = _ref12.config;
            state = getState();
            reviewService = new _exchangeApiClient.ReviewService(config);
            reviewsFromState = reviewsSelectors.reviews(state, {
              groupId: groupId,
              assetId: assetId,
              minorVersion: minorVersion,
              version: version
            });
            if (!(reviewsFromState && (reviewsFromState === null || reviewsFromState === void 0 ? void 0 : reviewsFromState.rating) !== null && (reviewsFromState === null || reviewsFromState === void 0 ? void 0 : reviewsFromState.numberOfRates) !== null)) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return", reviewsFromState);
          case 6:
            context = sessionSelectors.context(state);
            reviews = null;
            _context2.prev = 8;
            dispatch(fetchReviewsRequest());
            _context2.next = 12;
            return reviewService.getRating({
              groupId: groupId,
              assetId: assetId,
              version: version,
              context: context
            });
          case 12:
            response = _context2.sent;
            reviews = {
              comments: reviewsFromState ? reviewsFromState.comments : null,
              rating: response.rating,
              numberOfRates: response.numberOfRates
            };
            if (response) {
              dispatch(fetchReviewsSuccess({
                reviews: reviews,
                groupId: groupId,
                assetId: assetId,
                minorVersion: minorVersion,
                version: version
              }));
            }
            _context2.next = 21;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](8);
            dispatch(fetchReviewsFailure());
            throw _context2.t0;
          case 21:
            return _context2.abrupt("return", reviews);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[8, 17]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref13.apply(this, arguments);
    };
  }();
}

/** Gets reviews for the asset portal */
function getReviews(_ref14) {
  var groupId = _ref14.groupId,
    assetId = _ref14.assetId,
    minorVersion = _ref14.minorVersion,
    version = _ref14.version;
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch, getState, _ref15) {
      var config, state, reviewService, reviewsFromState, context, response, reviews;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            config = _ref15.config;
            state = getState();
            reviewService = new _exchangeApiClient.ReviewService(config);
            reviewsFromState = reviewsSelectors.reviews(state, {
              groupId: groupId,
              assetId: assetId,
              minorVersion: minorVersion,
              version: version
            });
            if (!(reviewsFromState && reviewsFromState.comments !== null)) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return", reviewsFromState);
          case 6:
            context = sessionSelectors.context(state);
            response = null;
            reviews = null;
            _context3.prev = 9;
            dispatch(fetchReviewsRequest());
            _context3.next = 13;
            return reviewService.list({
              groupId: groupId,
              assetId: assetId,
              version: version,
              context: context
            });
          case 13:
            response = _context3.sent;
            reviews = {
              comments: response,
              rating: reviewsFromState ? reviewsFromState.rating : null,
              numberOfRates: reviewsFromState ? reviewsFromState.numberOfRates : null
            };
            if (response) {
              dispatch(fetchReviewsSuccess({
                reviews: reviews,
                groupId: groupId,
                assetId: assetId,
                minorVersion: minorVersion,
                version: version
              }));
            }
            _context3.next = 22;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](9);
            dispatch(fetchReviewsFailure());
            throw _context3.t0;
          case 22:
            return _context3.abrupt("return", reviews);
          case 23:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[9, 18]]);
    }));
    return function (_x7, _x8, _x9) {
      return _ref16.apply(this, arguments);
    };
  }();
}

/** Deletes a review from the asset portal */
function deleteReview(_ref17) {
  var groupId = _ref17.groupId,
    assetId = _ref17.assetId,
    minorVersion = _ref17.minorVersion,
    version = _ref17.version,
    reviewId = _ref17.reviewId;
  return /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch, getState, _ref18) {
      var config, state, reviewService, context;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            config = _ref18.config;
            state = getState();
            reviewService = new _exchangeApiClient.ReviewService(config);
            context = sessionSelectors.context(state);
            dispatch(deleteReviewRequest({
              id: reviewId,
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion
            }));
            _context4.next = 7;
            return reviewService.remove({
              groupId: groupId,
              assetId: assetId,
              version: version,
              id: reviewId,
              context: context
            });
          case 7:
            dispatch(deleteReviewSuccess());
            dispatch(updateRating({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion
            }));
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x10, _x11, _x12) {
      return _ref19.apply(this, arguments);
    };
  }();
}

/** Edits an existing review on the asset portal */
function editReview(_ref20) {
  var groupId = _ref20.groupId,
    assetId = _ref20.assetId,
    minorVersion = _ref20.minorVersion,
    version = _ref20.version,
    review = _ref20.review;
  return /*#__PURE__*/function () {
    var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch, getState, _ref21) {
      var config, state, reviewService, context, updatedDate, response;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            config = _ref21.config;
            state = getState();
            reviewService = new _exchangeApiClient.ReviewService(config);
            context = sessionSelectors.context(state);
            updatedDate = new Date(Date.now()).toISOString();
            dispatch(editReviewRequest({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              reviewToUpdate: _objectSpread(_objectSpread({}, review), {}, {
                updatedDate: updatedDate
              })
            }));
            _context5.prev = 6;
            _context5.next = 9;
            return reviewService.update({
              groupId: groupId,
              assetId: assetId,
              version: version,
              id: review.id,
              text: review.text,
              title: review.title,
              rating: review.rating,
              context: context
            });
          case 9:
            response = _context5.sent;
            dispatch(editReviewSuccess());
            dispatch(updateRating({
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion
            }));
            return _context5.abrupt("return", response);
          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](6);
            dispatch(editReviewFailure());
            throw _context5.t0;
          case 19:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[6, 15]]);
    }));
    return function (_x13, _x14, _x15) {
      return _ref22.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map